<template>
  <div>
    <b-row>
      <b-col lg="6">
        <b-card id="advertisementscard">
          <b-card-body id="advertisementsbody">
            <b-card-title id="advertisementsheader"> Werbungen </b-card-title>
            <b-card-text>
              <b-row>
                <b-col lg="4">Bestätigt</b-col>
                <b-col lg="4">Ausständig</b-col>
                <b-col lg="4">Abgelehnt</b-col>
              </b-row>
              <b-row>
                <b-col
                  v-for="(count, index) in getAdsStats"
                  :key="`ad_stats_${index}`"
                >
                  {{ count }}
                </b-col>
              </b-row>
              <br />
              <b-row style="justify-content: center"
                ><pie-chart
                  v-if="showDashboard"
                  class="piechart-test"
                  :data="chartDataAds"
                  :options="chartOptions"
                ></pie-chart
              ></b-row>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="6">
        <b-card id="plannercard">
          <b-card-body id="plannerbody">
            <b-card-title id="plannerheader">
              Werbekampagnen (Planer)
            </b-card-title>
            <b-card-text>
              <b-row>
                <b-col lg="4">derzeit ausgestrahlte Kampagnen</b-col>
                <b-col lg="4">vergangene Kampagnen</b-col>
                <b-col lg="4">zukünftige Kampagnen</b-col>
              </b-row>
              <b-row>
                <b-col
                  v-for="(count, index) in getPlannerStats"
                  :key="`planner_stats_${index}`"
                >
                  {{ count }}
                </b-col>
              </b-row>
              <br />
              <b-row style="justify-content: center"
                ><pie-chart
                  v-if="showDashboard"
                  class="piechart-test"
                  :data="chartDataPlanner"
                  :options="chartOptions"
                ></pie-chart
              ></b-row>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col lg="12">
        <b-card id="interactionscard">
          <b-card-body id="interactionsbody">
            <b-card-title id="interactionsheader"> Interaktionen </b-card-title>
            <b-card-text>
              <b-row>
                <b-col
                  v-for="(item, index) in getActiveMenusSidebarInOrder"
                  :key="`${index}_dashboard_${item.menuTitle}`"
                  >{{ item.menuTitle }}</b-col
                >
              </b-row>
              <b-row>
                <b-col
                  v-for="(count, index) in getInteractionsStats"
                  :key="`interaction_stats_${index}`"
                  >{{ count }}</b-col
                >
              </b-row>
              <br />
              <b-row style="justify-content: center"
                ><pie-chart
                  v-if="interactionstatsLoaded"
                  class="piechart-test"
                  :data="getInteractionChartData"
                  :options="chartOptions"
                ></pie-chart
              ></b-row>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Test from "./Test";
import BarChart from "./BarChartTest";
import PieChart from "../assets/charts/PieChart.js";
import DoughnutChart from "../assets/charts/DoughnutChart";

import notificationmixin from "../mixins/notificationmixin";

export default {
  mixins: [notificationmixin],
  data() {
    return {
      showDashboard: false,
      monitorstatsLoaded: false,
      publicitystatsLoaded: false,
      interactionstatsLoaded: false,
      chartOptions: {
        legend: {
          display: true,
          labels: {
            fontColor: "rgb(255, 255, 255)",
          },
          align: "center",
          position: "bottom",
        },
      },
      chartDataAds: {
        labels: ["Bestätigt", "Ausständig", "Abgelehnt"],
        datasets: [
          {
            label: "Data One",
            backgroundColor: ["#41B883", "#00D8FF", "#E46651"],
            data: [],
          },
        ],
      },
      chartDataPlanner: {
        labels: [
          "derzeit ausgestrahlte Kampagnen",
          "vergangene Kampagnen",
          "zukünftige Kampagnen",
        ],
        datasets: [
          {
            label: "Data One",
            backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            data: [],
          },
        ],
      },
      chartDataInteractions: {
        labels: [
          "Impressionen (Heute)",
          "Impressionen (Gesamt)",
          "Werbeklicks",
          "Reichweite",
        ],
        datasets: [
          {
            backgroundColor: ["#41B883", "#00D8FF", "#F5EC42", "#E46651"],
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions(["loadSidebarMenus", "loadStats"]),
    async loadStatistics() {
      // since charts are not reactive, wait for data before rendering graphs
      let promises = [];
      promises.push(this.loadStats("ads"));
      promises.push(this.loadStats("planner"));
      // promises.push(this.loadStats("interactions"));

      await Promise.all(promises);
    },
    getAdsChartData: function () {
      this.chartDataAds.datasets[0].data.push(this.getAdsStats.confirmedCount);
      this.chartDataAds.datasets[0].data.push(this.getAdsStats.pendingCount);
      this.chartDataAds.datasets[0].data.push(this.getAdsStats.rejectedCount);
      return this.chartDataAds;
    },
    getPlannerChartData: function () {
      this.chartDataPlanner.datasets[0].data.push(
        this.getPlannerStats.pastPlannerCount
      );
      this.chartDataPlanner.datasets[0].data.push(
        this.getPlannerStats.currentPlannerCount
      );
      this.chartDataPlanner.datasets[0].data.push(
        this.getPlannerStats.futurePlannerCount
      );
      return this.chartDataPlanner;
    },
    getInteractionsChartData: function () {
      this.chartDataInteractions.datasets[0].data.push(
        this.getInteractionsStats.confirmedCount
      );
      this.chartDataInteractions.datasets[0].data.push(
        this.getInteractionsStats.pendingCount
      );
      this.chartDataInteractions.datasets[0].data.push(
        this.getInteractionsStats.rejectedCount
      );
      this.chartDataInteractions.datasets[0].data.push(
        this.getInteractionsStats.rejectedCount
      );
      return this.chartDataInteractions;
    },
  },
  computed: {
    ...mapGetters(["getAdsStats", "getPlannerStats", "getInteractionsStats"]),
  },
  mounted: async function () {
    try {
      await this.loadStatistics();

      this.chartDataAds.datasets[0].data.push(this.getAdsStats.confirmedCount);
      this.chartDataAds.datasets[0].data.push(this.getAdsStats.pendingCount);
      this.chartDataAds.datasets[0].data.push(this.getAdsStats.rejectedCount);

      this.chartDataPlanner.datasets[0].data.push(
        this.getPlannerStats.pastPlannerCount
      );
      this.chartDataPlanner.datasets[0].data.push(
        this.getPlannerStats.currentPlannerCount
      );
      this.chartDataPlanner.datasets[0].data.push(
        this.getPlannerStats.futurePlannerCount
      );

      this.showDashboard = true;
    } catch (error) {
      this.notify(
        1,
        ``,
        `Dashboard konnte nicht geladen werden. Bitte versuchen Sie es später erneut oder kontaktieren Sie einen Administrator`,
        this.$toast
      );
    }
  },
  components: {
    Test,
    BarChart,
    PieChart,
    DoughnutChart,
  },
};
</script>

<style scoped>
.piechart-test {
  height: 250px;
  width: 250px;
}

.card {
  color: white;
}
.card-title {
  text-align: start;
}
.card-text {
  text-align: center;
}

#advertisementscard {
  background-color: #20a8d8;
  border-color: #187da0;
}
#plannercard {
  background-color: #ffc107;
  border-color: #c69500;
}
#electionscard {
  background-color: #4dbd74;
  border-color: #379457;
}
#contactscard {
  background-color: #c8ced3;
  border-color: #a5aeb7;
  color: black;
}
#reportscard {
  background-color: #f86c6b;
  border-color: #f5302e;
}
#infoscard {
  background-color: #63c2de;
  border-color: #2eadd3;
}

#monitorcard {
  background-color: #4dbd74;
  border-color: #379457;
}
#publicitycard {
  background-color: #ffc107;
  border-color: #c69500;
}
#interactionscard {
  background-color: #20a8d8;
  border-color: #187da0;
}
</style>
